// extracted by mini-css-extract-plugin
export default {"fs":"_4d002f2b78 bd2de6e29c"};